const avatarExtractRegex = /([A-Za-z])[A-Za-z]*\s?/gi;

function getAvatarName(name: string, limit: number = 2) {
  return name.replace(avatarExtractRegex, "$1").slice(0, limit);
}

export default getAvatarName;
